<template>
	<div>
		<DotLoadingPage v-if="loading" />
	</div>
</template>

<script>
import DotLoadingPage from '@/components/dot-loading-page/DotLoadingPage.vue';

export default {
	name: 'RedirectLinkedin',
	components: { DotLoadingPage },
	data() {
		return {
			loading: true,
		};
	},
	methods: {
		redirectToUrl(url) {
			const finalUrl = decodeURIComponent(url);
			window.location.href = finalUrl;
		},
		trackMixpanelEvent(event) {
			try {
				if (process.env.VUE_APP_MIXPANEL == 'production') {
					this.$mixpanel.track(event);
				}
			} catch (error) {
				console.error('Error tracking Mixpanel event:', error);
			}
		},
	},
	async mounted() {
		try {
			const url = window.location.href;
			const paramsString = url.split('?')[1]; // Get params string from url

			if (paramsString == null) return;

			// Check params string includes string "startTask=CERTIFICATION_NAME"
			if (paramsString.includes('CERTIFICATION_NAME')) {
				this.trackMixpanelEvent('linkedin-add-certificate-to-profile');
				const cleanPart = paramsString.replace('link=', '');
				this.redirectToUrl(cleanPart);
				return;
			}

			// Check params string includes string "share-offsite"
			if (paramsString.includes('share-offsite')) {
				this.trackMixpanelEvent('linkedin-share-certificate-as-a-post');
				const cleanPart = paramsString.replace('link=', '');
				this.redirectToUrl(cleanPart);
				return;
			}

			this.loading = false;
		} catch (error) {
			console.error('Error redirecting to LinkedIn:', error);
		}
	},
};
</script>
